var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collapsed",class:[
        {'onmobile' : _vm.isOnMobile},
        {'clicked' : _vm.sideBarExpandedWrapper},
        {'sidebar-expanded' : _vm.sideBarExpandedWrapper}

    ],attrs:{"id":"sidebar"}},[_c('sidebar-menu',_vm._b({attrs:{"menu":_vm.menus,"show-one-child":true,"collapsed":!_vm.sideBarExpandedWrapper},on:{"toggle-collapse":_vm.changeSideBarExpandedWrapper},nativeOn:{"mouseenter":function($event){_vm.isSidebarHovered = true},"mouseleave":function($event){_vm.isSidebarHovered = false}}},'sidebar-menu',_vm.settings,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }